import { GiftsByPrice } from "@/components/marketplace"
import type { GiftsByPriceSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { feedHeaderSize, SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const GiftsByPriceFeedSection = ({ section, context }: FeedSectionProps<GiftsByPriceSection>) => {
  const { title } = section.presentation
  if (!title || section.data.tiers.length === 0) return null
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <GiftsByPrice
        title={title.text}
        accent={title.accent}
        headerSize={feedHeaderSize(title.style)}
        numeral={title.numeral}
        tiers={section.data.tiers.map((tier) => {
          const query = tier.link.kind === "SEARCH" ? tier.link.query : undefined
          return {
            id: tier.id,
            label: tier.label,
            href: resolveFeedLink(tier.link, context.countryCode, context.page),
            minPrice: query?.minPrice,
            maxPrice: query?.maxPrice,
            serveId: tier.serveId,
          }
        })}
      />
    </SectionFrame>
  )
}
